import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { LanguageService, AuthorizationService, PeopleService, ApplicationService } from './shared/services';
import { InformationComponent } from './modal/information.component';
import { filter, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ModalComponent } from './modal/modal.component';
import { NewVersionModalComponent } from './shared/components';
import { AppVersion } from './shared/models';
import { ConnectionCheck } from './utils/connection-check';
import { AppConstants } from './utils/appConstants.class';
import { UpgradesPluginService } from './plugins/upgrades/upgrades-plugin.service';
import { ObsolescencesPluginService } from './plugins/obsolescences/obsolescences-plugin.service';

@Component({
    selector: 'ir-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.css'],
    standalone: false
})
export class AppComponent implements OnInit {
  @ViewChild('connectionNotification', { static: true }) connectionNotification: InformationComponent;
  @ViewChild('versionModal', { static: true }) versionModal: ModalComponent;
  @ViewChild('upgradeModal', { static: true }) upgradeModal: ModalComponent;
  public connectionMessage: string;

  @HostListener('window:customoffline', ['$event']) onCustomOffline(evt) {
    this.connectionMessage = 'offline.notifications.offline';
    this.connectionNotification.open();
  }
  @HostListener('window:customonline', ['$event']) onCustomOnline(evt) {
    this.connectionMessage = 'offline.notifications.online';
    this.connectionNotification.open();
  }
  @HostListener('window:offline', ['$event']) onOffline(evt) {
    ConnectionCheck.checkConnection();
  }
  @HostListener('window:online', ['$event']) onOnline(evt) {
    ConnectionCheck.checkConnection();
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private language: LanguageService,
    private authorization: AuthorizationService,
    private peopleService: PeopleService,
    private applicationService: ApplicationService,
    private upgradePluginService: UpgradesPluginService,
    private obsolescencesPluginService: ObsolescencesPluginService
  ) {}

  ngOnInit() {
    ConnectionCheck.checkConnection();

    // subscribe to router event
    // this.language.initLanguage();
    this.activatedRoute.queryParams.subscribe((queryParams: Params) => {
      const url = queryParams['url'];
      if (url != null) {
        this.router.navigate([url]);
      }
    });

    this.peopleService
      .getPermissions()
      .pipe(
        switchMap((res) => {
          if (res) {
            return this.applicationService.getNewApplicationVersion();
          }
          return of(null);
        })
      )
      .subscribe((res) => {
        if (res && res.currentVersion !== res.personCurrentVersion) {
          this.openVersionModal(res.appVersion);
        }
      });

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      setTimeout(() =>
        sessionStorage.setItem(
          AppConstants.LAST_OPENED_PLUGIN_ID,
          this.activatedRoute.firstChild?.snapshot.paramMap.get('pluginId')
        )
      );
    });
    this.upgradePluginService.setUpgradeModal(this.upgradeModal);
    this.obsolescencesPluginService.setObsolescencesModal(this.upgradeModal);
    this.upgradePluginService.getUpgradesDetailsConfig('').subscribe();
    this.obsolescencesPluginService.getObsolescencesDetailsConfig('').subscribe();
  }

  private openVersionModal(appVersion: AppVersion) {
    this.versionModal.hasClassModal = true;
    this.versionModal.open(NewVersionModalComponent, {
      appVersion
    });
  }
}
